
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-constructor",
      function () {
        return require("private-next-pages/sell-constructor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-constructor"])
      });
    }
  